import template from './fileImportantDates.html';
import controller from './fileImportantDatesCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanAppId: '<',
    scenarioDetails: '<',
  },
};
